const FooterPage = () => {

    return (
        <footer className="p-6 mx-auto container text-neutral-100 border-t border-blue-500 flex flex-row gap-4">
            <div>
                <p className="text-center italic font-semi-bold">© 2025-2026 vehicle.worldercraft.fr All Rights Reserved.</p>
            </div>
        </footer>
    );
};

export default FooterPage;
